import './styles.scoped.css'
import {Typography, Button, Modal} from '@mui/material'
import {Warning} from '@mui/icons-material'

// message is the server's account of the clash (the caregiver booked, the date and the times), when it gave one.
export default ({open, setOpen, message}) => {
    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Warning color="warning" />
                        <br />
                        <br />
                        <Typography variant="h6" color="warning">
                            Schedule Conflict Detected
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        The visit you are trying to schedule overlaps with an existing schedule. Please review the schedules and adjust the visit time
                        before continuing.
                    </Typography>
                    {message && (
                        <>
                            <br />
                            <Typography variant="body2" color="text.secondary" style={{textAlign: 'center'}}>
                                {message}
                            </Typography>
                        </>
                    )}
                    <br />
                    <br />
                    <div className="actions">
                        <Button variant="contained" fullWidth onClick={() => setOpen(false)}>
                            Edit Schedule
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
